import React from 'react'
import { useTranslation } from 'react-i18next'
import ru from '../../assets/ru.svg'
import tk from '../../assets/tk.svg'
import en from '../../assets/en.svg'
import { Link } from 'react-router-dom'


const Language_dropdown = () => {

    const { i18n } = useTranslation()


    const items = [
        {
            img: en,
            value: "en",
        },
        {
            img: tk,
            value: "tk",
        },
        {
            img: ru,
            value: "ru",
        },
    ];


    return (
        <div className='flex flex-row gap-x-2 max-[991px]:gap-x-4'>
            {items.map(item => (
                <div key={item.value} className='bg-transparent cursor-pointer' onClick={() => { i18n.changeLanguage(String(item.value)); localStorage.setItem("lang", String(item.value)) }}>
                <img src={item.img}/>
                </div>
            ))}
        </div>
    )
}

export default Language_dropdown